import { productGalleryTabsSX } from '@/components/blocks/ProductDetails/styles/productGalleryTabs';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, Typography } from '@mui/material';
import {
	MATERIAL_SYMBOL_ICONS,
	OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

interface ProductDetailsArQrCodeProps {
	arQRImageBase64: string;
}

export const ProductDetailsArQrCode = ({ arQRImageBase64 }: ProductDetailsArQrCodeProps) => {
	const { Title, Instructions } = useLocalization('ArQrCodePanel');

	return (
		<Box sx={productGalleryTabsSX.arTab} id="mediaAR">
			<Box sx={productGalleryTabsSX.arTabHeader}>
				<DynamicIcon name={MATERIAL_SYMBOL_ICONS.viewInAr} size={48} />
				<Typography
					variant="headingHeadline"
					textAlign="center"
					fontWeight={OpenSansFontWeights.light}
				>
					{Title.t()}
				</Typography>
				<Typography variant="bodyBaseline" textAlign="center">
					{Instructions.t()}
				</Typography>
			</Box>
			<Box sx={productGalleryTabsSX.qrContainer}>
				<img
					height="270px"
					width="270px"
					src={arQRImageBase64}
					loading="lazy"
					alt={Instructions.t()}
				/>
			</Box>
		</Box>
	);
};
